import React, { useMemo, useReducer } from 'react';
import PropTypes from 'prop-types';
import ResourceUserDetailsContext from './ResourceUserDetailsContext';
import resourceUserDetailsReducer from './hooks/resourceUserDetailsReducer';
import { NUDGE_TYPE_KEY } from './hooks/useRegisterGlobalNudgesCallback';

const initialState = {
  snackbarMessage: null,
  globalNudges: {
    [NUDGE_TYPE_KEY.SKILL_NUDGES]: null,
    [NUDGE_TYPE_KEY.CERTIFICATE_NUDGES]: null
  }
};

const ResourceUserDetailsContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    resourceUserDetailsReducer,
    initialState
  );

  const contextValues = useMemo(() => ({ state, dispatch }), [state]);

  return (
    <ResourceUserDetailsContext.Provider value={contextValues}>
      {children}
    </ResourceUserDetailsContext.Provider>
  );
};

ResourceUserDetailsContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default ResourceUserDetailsContextProvider;
